var scope_0 = require('/home/ilovepie/Projects/dllInjectionPresentation/libraryInjectionDeck/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/371a1c831277a5fa2c83647d34b21470.js').default;export default
        Object.assign({}, scope_0 )
    